<!--
 * @Description: 首页/企业认证
 * @Author: yingbin
 * @LastEditTime: 2019-09-25 16:11:51
 * @LastEditors: yingbin
 * @LastEditors: yingbin
 -->
<template>
  <div class="companyInfo">
    <div class="auth">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="200px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="公司名称：" prop="cp_name">
          <el-input
            v-model="ruleForm.cp_name"
            @blur="ruleForm.cp_name = $event.target.value.trim()"
            placeholder="请填写公司全称"
            maxlength="30"
          ></el-input>
        </el-form-item>
        <div class="block">
          <el-form-item label="公司地址：" prop="cp_city">
            <el-cascader
              ref="myCascader"
              placeholder="请点击选择省市区"
              v-model="ruleForm.cp_city"
              :options="options"
              :props="{ expandTrigger: 'hover' }"
              @change="handleChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item label=" " prop="cp_address" class="address">
            <el-input
              v-model="ruleForm.cp_address"
              @blur="ruleForm.cp_address = $event.target.value.trim()"
              placeholder="请填写详细地址"
              maxlength="30"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="所属行业：" prop="industry">
          <el-select v-model="ruleForm.industry" placeholder="请选择所属行业" @change="choseIndustry">
            <el-option :label="item" :value="item" v-for="(item,index) in industry" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统一社会信用代码：" prop="creditCode">
          <el-input maxlength="18" v-model="ruleForm.creditCode" placeholder="请填写统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item label="三证合一证件：" prop="three_img">
          <el-upload
            ref="uploads"
            :action="upLoadUrl"
            list-type="picture-card"
            :file-list="fileList"
            :on-preview="handlePictureCardPreview"
            :on-change="(file,fileList)=>{return upLoadChange(file,fileList,0)}"
            :before-upload="beforeUpload"
            :on-success="upSuccess"
            :limit="1"
            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,0)}"
            :on-exceed="handleExceed"
            :data="{token:token,userName:userName}"
            class="three-img"
            accept="image/jpg, image/png, image/jpeg"
            :class="{'hide':uploadDisabled}"
          >
            <img class="add" src="@/assets/images/add-img.png" alt="">
            <i class="el-upload__text">上传图片</i>
            <div class="toolTip">
              <div class="tooltio-content">
                <img src="@/assets/images/credit-code.png" alt="">
                <p class="tooltip-title">说明</p>
                <p>
                  <span>1、</span>
                  <span>请上三证合一证清晰彩色扫描件 或数码照片</span>
                </p>
                <p>
                  <span>2、</span>
                  <span>证件请在有效期内，且年检通过</span>
                </p>
                <p>
                  <span>3、</span>
                  <span>印章必须齐全(当年成立的可无 年检章)</span>
                </p>
                <p>
                  <span>4、</span>
                  <span>证件需是由中国大陆工商局或 者市场监督管理局颁发</span>
                </p>
                <p>
                  <span>5、</span>
                  <span>支持JPG\PNG格式的照片</span>
                </p>
                <p>
                  <span>6、</span>
                  <span>大小不能超过2M</span>
                </p>
              </div>
            </div>
          </el-upload>
          <div v-show="fileList.length == 0" style="color:#f56c6c;">图片大小请勿超过1MB</div>
        </el-form-item>
        <el-form-item class="btn">
          <el-button @click.prevent="save">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import company from "@/apis/company_apis";
import { industry } from "@/configs/config";
import { companyRules } from "@/validate/rules";
import uitls from "@/utils/utils";
export default {
  data() {
    return {
      upLoadUrl:"/openapi-interface/common/uploadimg",
      industry: industry,
      value: [],
      options: [],
      companyId:"",
      ruleForm: {
        cp_name: "",
        cp_city: [],
        cp_address: "",
        industry: "", //行业
        creditCode: "",
        three_img: ""
      },
      rules: companyRules, // 公司认证规则
      fileList: [], //营业执照
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      token: "",
      userName:'',
      barcodeUrl:'',
    };
  },
  created() {
    this.token = uitls.getCookie("TOKEN");
    let nameSring = uitls.getCookie("USER_INFO");
    this.userName = nameSring;
     // 获取省市区地址
    company.getAllregions(this).then(res => {
      this.options = res.data;
    });
    if (this.$parent.companyInfo.creditUnionCode) {
      this.getBarcode();
    }
  },
  mounted() {},
  computed: {
    uploadDisabled() {
      return this.fileList.length > 0;
    }
  },
  methods: {
    // 公司省市区
    handleChange(value) {
      this.regionsCode = value;
      this.regionsName = this.$refs.myCascader.getCheckedNodes()[0].pathLabels;
    },
    // 选择行业
    choseIndustry(e) {
      console.log(e);
    },
    // 上传前
    beforeUpload(file) {
      const isJPG = /^image\/(png|jpeg|jpg)$/.test(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是 png/jpeg/jpg 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 1MB!");
      }
      return isJPG && isLt2M;
    },
    // 上传图片监听
    upLoadChange(file, fileList, index) {
      this.fileList = fileList;
    },
    // 上传成功
    upSuccess(res, file) {
      this.ruleForm.three_img = res.data.filename;
      this.$refs.ruleForm.clearValidate("three_img");
    },
    // 删除上传图片
    handleRemove(file, fileList, index) {
      this.fileList.splice(0, 1);
      this.ruleForm.three_img = "";
    },
    // 单击预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 图盘上传超出数量
    handleExceed() {
      this.$message.error("最多只能上传一张照片！");
    },
    // 保存
    save() {
      this.userId = this.$store.state.userInfo.userId;
      let that = this;
      that.$refs.ruleForm.validate(valid => {
        if (valid) {
          company.companyAuth(that).then(res => {
            if (res.success) {
              this.$message({
                type:"success",
                duration:'1000',
                message:"企业认证信息提交成功！",
                onClose:() => {
                  this.$parent.getCompanyInfo();
                }
              })
            }
          });
        } else {
          return false;
        }
      });
    },
    //获取图片
    getBarcode() {
       if(this.$parent.companyInfo.cardImg.includes("files")){
          this.$axios.get('/openapi-interface/companyImage',{
            withCredentials: true,
          }).then(res=>{
            this.barcodeUrl = res.data.data
            this.getParentData();
          })
       }else{
          this.$axios.get('/openapi-interface/companyImage',
              { 
                withCredentials: true,
                  //设定接收类型为blob,头部什么的自行添加
                responseType:'blob',
              }
          ).then(res=>{
            this.barcodeUrl=URL.createObjectURL(res.data);
            this.getParentData();
          })
      }
    },
    // 获取父组件数据回显
    getParentData() {
      let cp = this.$parent.companyInfo;
      this.ruleForm.cp_name = cp.companyName;
      this.ruleForm.cp_city = [
        cp.companyProvinceId,
        cp.companyCityId,
        cp.companyCountyId
      ];
      this.regionsCode = [
        cp.companyProvinceId,
        cp.companyCityId,
        cp.companyCountyId
      ];
      this.companyId = cp.companyId
      this.regionsName = [cp.companyProvince, cp.companyCity, cp.companyCounty];
      this.ruleForm.cp_address = cp.companyDetailAddr;
      this.ruleForm.industry = cp.industry;
      this.ruleForm.creditCode = cp.creditUnionCode;
      this.ruleForm.three_img = cp.cardImg;
      this.fileList.push({
        name: "0.jpg",
        url: this.barcodeUrl
      });
    }
  }
};
</script>
<style lang="less">
@import "../../assets/css/upload.less";
.address {
  /deep/label {
    &::before {
      content: "" !important;
    }
  }
  /deep/.el-form-item__error{
    padding-left: 10px;
  }
}
</style>
